// extracted by mini-css-extract-plugin
export var root = "i4st";
export var rootConsent = "Vtqm";
export var rootFeatureContent = "aUkb";
export var rootFooter = "jXUV";
export var rootForm = "Revh";
export var rootFormButton = "RDeU";
export var rootFormButtonLabel = "cNfj";
export var rootFormButtonLoader = "t8bS";
export var rootFormInput = "tMk7";
export var rootFormLabel = "buMA";
export var rootFormStatus = "g8oB";
export var rootFormStatusEmailTaken = "lb7b";
export var rootFormStatusInvalid = "Z0Bj";
export var rootFormStatusSubscribed = "_5anx";
export var rootSubheading = "fh+5";
export var rootV4Footer = "Rzqv";